import FormInputComponent from "@via/components/inputs/form-input-component";
import Modal from "@via/components/modal.tsx";
import { type FC, useEffect } from "react";
import { requiredValidation } from "@via/utils/form-validators.tsx";
import { useForm } from "react-hook-form";

interface UpdateSpreadsheetColumnsModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  spreadsheetColumn: { columnIndex: number; columns: string[] } | undefined;
  submitSpreadsheetColumn: (columnIndex: number, updatedColumnName) => void;
}

const UpdateSpreadsheetColumnsModal: FC<UpdateSpreadsheetColumnsModalProps> = ({
  open,
  setOpen,
  spreadsheetColumn,
  submitSpreadsheetColumn,
}) => {
  const { control, handleSubmit, reset } = useForm({
    mode: "onChange",
    defaultValues: {
      name: spreadsheetColumn?.columns?.[spreadsheetColumn?.columnIndex] ?? "",
    },
  });

  useEffect(() => {
    // Update the form values when the `spreadsheetColumn` prop changes
    reset({
      name: spreadsheetColumn?.columns?.[spreadsheetColumn?.columnIndex] ?? "",
    });
  }, [spreadsheetColumn, reset]);

  // Resolving true hands the close to Modal, and an empty name resolves false so
  // the dialog stays open on its required error. The parent used to close it from
  // inside submitSpreadsheetColumn, while this handler never settled at all.
  const handleConfirmModal = async (): Promise<boolean> => {
    let saved = false;
    await handleSubmit((payload: { name: string }) => {
      submitSpreadsheetColumn(
        spreadsheetColumn?.columnIndex ?? 0,
        payload.name
      );
      saved = true;
    })();
    return saved;
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Rename Column"
      confirmText="Save"
      onConfirm={handleConfirmModal}>
      <form onSubmit={e => e.preventDefault()}>
        <div className="my-5">
          <FormInputComponent
            name="name"
            label="Column Name"
            showRequiredField
            control={control}
            validations={requiredValidation("Column Name")}
          />
        </div>
      </form>
    </Modal>
  );
};

export default UpdateSpreadsheetColumnsModal;
